import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import {
  IAvansnaUplataRacunaTableDto,
  VrstaRacuna,
} from '@kodit/core/data-api';
import { Injectable } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class AvansnaUplataRacunaFormService {
  constructor(private _fb: FormBuilderTypeSafe) {}

  public GetAvansneUplateRacunaFormArray(
    avansneUplate: IAvansnaUplataRacunaTableDto[]
  ): FormArray {
    if (!avansneUplate || avansneUplate.length === 0) {
      return this._fb.array([]);
    }

    let result: FormArray = this._fb.array([]);
    avansneUplate.forEach((x) => {
      result.push(this.GetAvansneUplateRacunaFormGroup(x));
    });
    return result;
  }

  public GetAvansneUplateRacunaFormGroup(
    model?: IAvansnaUplataRacunaTableDto
  ): FormGroupTypeSafe<IAvansnaUplataRacunaTableDto> {
    return this._fb.group<IAvansnaUplataRacunaTableDto>({
      id: new FormControl(model?.id),
      avansniRacunBroj: new FormControl(model?.avansniRacunBroj),
      avansniRacunId: new FormControl(model?.avansniRacunId ?? 0),
      avansniRacunVrsta: new FormControl(
        model?.avansniRacunVrsta ?? VrstaRacuna.EMPTY
      ),
      avansniRacunDatumIzdavanja : new FormControl(model?.avansniRacunDatumIzdavanja ?? new Date()),
      evidentiranPdv8: new FormControl(model?.evidentiranPdv8),
      evidentiranPdv10: new FormControl(model?.evidentiranPdv10),
      evidentiranPdv20: new FormControl(model?.evidentiranPdv20),
      evidentiranaOsnovica8: new FormControl(model?.evidentiranaOsnovica8),
      evidentiranaOsnovica10: new FormControl(model?.evidentiranaOsnovica10),
      evidentiranaOsnovica20: new FormControl(model?.evidentiranaOsnovica20),
      evidentiranaOsnovicaAE: new FormControl(model?.evidentiranaOsnovicaAE),
      evidentiranaOsnovicaAE10: new FormControl(model?.evidentiranaOsnovicaAE10),
      evidentiranaOsnovicaAE20: new FormControl(model?.evidentiranaOsnovicaAE20),
      evidentiranaOsnovicaE: new FormControl(model?.evidentiranaOsnovicaE),
      evidentiranaOsnovicaN: new FormControl(model?.evidentiranaOsnovicaN),
      evidentiranaOsnovicaO: new FormControl(model?.evidentiranaOsnovicaO),
      evidentiranaOsnovicaOE: new FormControl(model?.evidentiranaOsnovicaOE),
      evidentiranaOsnovicaR: new FormControl(model?.evidentiranaOsnovicaR),
      evidentiranaOsnovicaSS: new FormControl(model?.evidentiranaOsnovicaSS),
      evidentiranaOsnovicaZ: new FormControl(model?.evidentiranaOsnovicaZ),
      ukupnaOsnovica8: new FormControl(model?.ukupnaOsnovica8),
      ukupnaOsnovica10: new FormControl(model?.ukupnaOsnovica10),
      ukupnaOsnovica20: new FormControl(model?.ukupnaOsnovica20),
      ukupnoPdv8: new FormControl(model?.ukupnoPdv8),
      ukupnoPdv10: new FormControl(model?.ukupnoPdv10),
      ukupnoPdv20: new FormControl(model?.ukupnoPdv20),
      ukupnaOsnovicaAE: new FormControl(model?.ukupnaOsnovicaAE),
      ukupnaOsnovicaAE10: new FormControl(model?.ukupnaOsnovicaAE10),
      ukupnaOsnovicaAE20: new FormControl(model?.ukupnaOsnovicaAE20),
      ukupnaOsnovicaO: new FormControl(model?.ukupnaOsnovicaO),
      ukupnaOsnovicaE: new FormControl(model?.ukupnaOsnovicaE),
      ukupnaOsnovicaR: new FormControl(model?.ukupnaOsnovicaR),
      ukupnaOsnovicaZ: new FormControl(model?.ukupnaOsnovicaZ),
      ukupnaOsnovicaSS: new FormControl(model?.ukupnaOsnovicaSS),
      ukupnaOsnovicaOE: new FormControl(model?.ukupnaOsnovicaOE),
      ukupnaOsnovicaN: new FormControl(model?.ukupnaOsnovicaN),
      uplataEvidentiranaOsnovica8: new FormControl(model?.uplataEvidentiranaOsnovica8),
      uplataEvidentiranaOsnovica10: new FormControl(model?.uplataEvidentiranaOsnovica10),
      uplataEvidentiranaOsnovica20: new FormControl(model?.uplataEvidentiranaOsnovica20),
      uplataEvidentiranPdv8: new FormControl(model?.uplataEvidentiranPdv8),
      uplataEvidentiranPdv10: new FormControl(model?.uplataEvidentiranPdv10),
      uplataEvidentiranPdv20: new FormControl(model?.uplataEvidentiranPdv20),
      uplataEvidentiranaOsnovicaAE: new FormControl(model?.uplataEvidentiranaOsnovicaAE),
      uplataEvidentiranaOsnovicaAE10: new FormControl(model?.uplataEvidentiranaOsnovicaAE10),
      uplataEvidentiranaOsnovicaAE20: new FormControl(model?.uplataEvidentiranaOsnovicaAE20),
      uplataEvidentiranaOsnovicaO: new FormControl(model?.uplataEvidentiranaOsnovicaO),
      uplataEvidentiranaOsnovicaE: new FormControl(model?.uplataEvidentiranaOsnovicaE),
      uplataEvidentiranaOsnovicaR: new FormControl(model?.uplataEvidentiranaOsnovicaR),
      uplataEvidentiranaOsnovicaZ: new FormControl(model?.uplataEvidentiranaOsnovicaZ),
      uplataEvidentiranaOsnovicaSS: new FormControl(model?.uplataEvidentiranaOsnovicaSS),
      uplataEvidentiranaOsnovicaOE: new FormControl(model?.uplataEvidentiranaOsnovicaOE),
      uplataEvidentiranaOsnovicaN: new FormControl(model?.uplataEvidentiranaOsnovicaN)
    });
  }
}
